var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Icon__StyledIcon-sc-1det6wr-0 eZmcIX",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.997 2A7.926 7.926 0 004.08 9.917c0 5.456 5.449 10.407 7.118 11.794a1.25 1.25 0 001.597 0c1.667-1.387 7.119-6.34 7.119-11.795A7.926 7.926 0 0011.997 2zm0 12.084a4.167 4.167 0 114.167-4.167 4.167 4.167 0 01-4.167 4.167z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.06fe5fbcab3c0fffb4a006c9374b0057.svg";
export { ForwardRef as ReactComponent };